import axios from 'axios'
import BaseInterceptors from './interseptors/base-interseptors'
import { API_URL } from '../../env'

// set up local or production
const baseDomain = API_URL
const baseURL = `${baseDomain}`

const axiosInstance = axios.create({
    baseURL,
})
BaseInterceptors.use(axiosInstance)

export default axiosInstance
